(() => {
  if (window.__ctGridTextFit) return;
  window.__ctGridTextFit = true;

  const availableWidth = (box) => {
    const boxWidth = box.clientWidth;
    const insert = box.closest('.ct-grid-insert');
    if (!insert) return boxWidth;
    const styles = getComputedStyle(insert);
    const inner =
      insert.clientWidth -
      parseFloat(styles.paddingLeft || '0') -
      parseFloat(styles.paddingRight || '0');
    if (!boxWidth) return Math.max(0, inner);
    return Math.max(0, Math.min(boxWidth, inner));
  };

  const sources = new WeakMap();

  const measureText = (measurer, text) => {
    measurer.textContent = text;
    return measurer.getBoundingClientRect().width;
  };

  const splitLongWord = (word, available, measurer) => {
    const pieces = [];
    let piece = '';
    Array.from(word).forEach((character) => {
      const candidate = piece + character;
      if (piece && measureText(measurer, candidate) > available) {
        pieces.push(piece);
        piece = character;
      } else {
        piece = candidate;
      }
    });
    if (piece) pieces.push(piece);
    return pieces;
  };

  const makeLines = (text, available, measurer) => {
    const words = text.trim().split(/\s+/).filter(Boolean);
    const lines = [];
    let current = '';

    words.forEach((word) => {
      const parts = measureText(measurer, word) > available
        ? splitLongWord(word, available, measurer)
        : [word];

      parts.forEach((part) => {
        const candidate = current ? `${current} ${part}` : part;
        if (current && measureText(measurer, candidate) > available) {
          lines.push(current);
          current = part;
        } else {
          current = candidate;
        }
      });
    });

    if (current) lines.push(current);
    return lines;
  };

  const fitParagraph = (paragraph, available) => {
    if (!sources.has(paragraph)) sources.set(paragraph, paragraph.textContent || '');
    const source = sources.get(paragraph).trim();
    paragraph.replaceChildren();
    if (!source || !available) return;

    const measurer = document.createElement('span');
    measurer.className = 'ct-grid-insert__measure';
    paragraph.append(measurer);

    makeLines(source, available, measurer).forEach((text) => {
      const line = document.createElement('span');
      line.className = 'ct-grid-insert__fitted-line';
      line.textContent = text;
      paragraph.insertBefore(line, measurer);

      const characterCount = Array.from(text).length;
      const naturalWidth = measureText(measurer, text);
      if (characterCount > 1 && naturalWidth > 0 && naturalWidth < available) {
        const spacing = Math.min((available - naturalWidth) / (characterCount - 1), 24);
        if (spacing > 0) line.style.letterSpacing = `${spacing}px`;
      }
    });

    measurer.remove();
  };

  const fitBox = (box) => {
    const available = availableWidth(box);
    box.querySelectorAll(':scope > p').forEach((paragraph) => fitParagraph(paragraph, available));
  };

  const fitFrom = (target) => {
    if (target.classList?.contains('ct-grid-insert__body--fill')) {
      fitBox(target);
      return;
    }
    target.querySelectorAll?.('.ct-grid-insert__body--fill').forEach(fitBox);
  };

  const fitAll = (root = document) => {
    root.querySelectorAll?.('.ct-grid-insert__body--fill').forEach(fitBox);
  };

  let frame;
  const schedule = (root = document) => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => fitAll(root));
  };

  const observer = new ResizeObserver((entries) => {
    entries.forEach((entry) => fitFrom(entry.target));
  });

  const observe = (root = document) => {
    root.querySelectorAll?.('.ct-grid-insert__body--fill').forEach((box) => {
      observer.observe(box);
      const insert = box.closest('.ct-grid-insert');
      if (insert) observer.observe(insert);
      fitBox(box);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => observe(), { once: true });
  } else {
    observe();
  }

  window.addEventListener('load', () => schedule());
  window.addEventListener('resize', () => schedule());
  document.fonts?.ready.then(() => schedule());
  document.addEventListener('shopify:section:load', (event) => observe(event.target));
  document.addEventListener('shopify:block:select', (event) => schedule(event.target));
})();
